import { h, Component, Fragment } from "preact";
import { useEffect } from "react";

import { observer } from "mobx-react";
import classnames from "classnames";

import { Autocomplete as LibraryAutocomplete } from "@searchspring/snap-preact-components";

import { Result } from "../Result/Result";

import { IconCtaArrow } from "../Icons/IconCtaArrow";

import "./autocomplete.css";

@observer
export class Autocomplete extends Component {
  render() {
    const controller = this.props.controller;
    const autocompleteStrings =
      window.Resources?.searchspring?.autocomplete ?? {};

    const resultsTitle = controller.store.state.input
      ? autocompleteStrings.recommendedProducts
      : autocompleteStrings.popularProducts;

    return (
      <LibraryAutocomplete
        controller={controller}
        input={controller.config.selector}
        hideFacets
        hideBanners
        termsTitle={autocompleteStrings.suggestions}
        trendingTitle={autocompleteStrings.topSearches}
        contentTitle={resultsTitle}
        resultsSlot={<AutocompleteResults />}
        noResultsSlot={<AutocompleteNoResults />}
        termsSlot={<AutocompleteTerms />}
        hideTrending={false}
      />
    );
  }
}

// For reference, you can see where this slot component gets used by the library Autocomplete component here:
// https://github.com/searchspring/snap/blob/main/packages/snap-preact-components/src/components/Organisms/Autocomplete/Autocomplete.tsx#L503
const AutocompleteResults = ({ results, contentTitle, controller }) => {
  const numberOfResultsToShowDesktop = 5; // magic number - could later be shopify setting driven
  const numberOfResultsToShowMobile = 4;
  const resultsToShowDesktop = results.slice(0, numberOfResultsToShowDesktop);
  const resultsToShowTabletAndMobile = results.slice(0, numberOfResultsToShowMobile);

  const { state } = controller.store;

  const parentContainer = document.querySelector('.ss__autocomplete--target');

  useEffect(() => {  
    parentContainer.style.opacity = 1;
  }, []);

  const autocompleteStrings =
    window.Resources?.searchspring?.autocomplete ?? {};

  return (
    <>
      <div className="ss__autocomplete__results-wrap">
        {contentTitle && (
          <div
            className={
              "ss__autocomplete__title ss__autocomplete__title--content"
            }
          >
            <h5 className="ss__autocomplete__recommended--heading eyebrow eyebrow--medium">
              {contentTitle}
            </h5>
          </div>
        )}

        <div className="ss__autocomplete__results ss__autocomplete__results--desktop small-hide medium-hide">
          {resultsToShowDesktop.map((result, index) => (
            <div className={`ss__autocomplete__result ss__autocomplete__result--${index + 1}`}>
              <Result result={result} hideBadge hideSwatches/>
            </div>
          ))}
        </div>

        <div className="ss__autocomplete__results ss__autocomplete__results--tablet-mobile large-up-hide">
          {resultsToShowTabletAndMobile.map((result, index) => (
            <div className={`ss__autocomplete__result ss__autocomplete__result--${index + 1}`}>
              <Result result={result} hideBadge hideSwatches/>
            </div>
          ))}
        </div>

        {!!state.input && results.length > 0 && (
          <div className="ss__autocomplete__view-all">
            <a
              className="ss__autocomplete__view-all__link button button--small button--secondary"
              href={state.url.href}
            >
              {autocompleteStrings.viewAllResults}
            </a>
          </div>
        )}
      </div>
    </>
  );
};

const AutocompleteNoResults = () => {
  const parentContainer = document.querySelector('.ss__autocomplete--target');

  useEffect(() => {  
    parentContainer.style.opacity = 1;
  }, []);

  return (
    <p className="ss__autocomplete__no-result eyebrow eyebrow--medium">
      {window.Resources?.searchspring?.autocomplete?.noResultsAutocomplete}
    </p>
  )
}


// For reference, you can see where this slot component gets used by the library Autocomplete component here:
// https://github.com/searchspring/snap/blob/main/packages/snap-preact-components/src/components/Organisms/Autocomplete/Autocomplete.tsx#L402
const AutocompleteTerms = (props) => {
  const {
    terms,
    trending,
    termsTitle,
    trendingTitle,
    showTrending,
    valueProps,
    emIfy,
    onTermClick,
    controller,
  } = props;
  const { state } = controller.store;

  const parentContainer = document.querySelector('.ss__autocomplete--target');

  //Hide Popular Terms showing up, if you hit Space after typing a No Results term
  useEffect(() => {  
    if (state.input) {
      //If the user entered a space
      if (state.input.includes(" ")) {

        //Check and see if No Results is preset
        const noResultsPresent = document.querySelector(".ss__autocomplete__content__no-results");

        if(noResultsPresent) {
          //If it is, hide the Popular Terms popping up
          const termsRender = document.querySelector(".ss__autocomplete__terms");

          if(!termsRender.classList.contains("hidden")) {
            termsRender.classList.add("hidden");
          }
        }
        //Else, if the user is just searching for a product name with a space in it
        else {
          const termsRender = document.querySelector(".ss__autocomplete__terms");
        
          if(termsRender.classList.contains("hidden")) {
            termsRender.classList.remove("hidden");
          }
        }
      }
      else {
        const termsRender = document.querySelector(".ss__autocomplete__terms");
        
        if(termsRender.classList.contains("hidden")) {
          termsRender.classList.remove("hidden");
        }
      }
    }
  });

  return (
    <>
      {terms.length > 0 ? (
        <>
          <div className="ss__autocomplete__inner-wrapper">
            {termsTitle ? (
              <div className="ss__autocomplete__title ss__autocomplete__title--terms">
                <h5 className="ss__autocomplete__terms-heading eyebrow eyebrow--medium">
                  {termsTitle}
                </h5>
              </div>
            ) : null}
            <div className="ss__autocomplete__terms__options">
              {terms.map((term) => (
                <div
                  className={classnames("ss__autocomplete__terms__option", "CQL-p3", {
                    "ss__autocomplete__terms__option--active": term.active,
                  })}
                >
                  <a
                    onClick={(e) => onTermClick && onTermClick(e)}
                    href={term.url.href}
                    {...valueProps}
                    onFocus={() => term.preview()}
                  >
                    {emIfy(term.value, state.input)}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </>
      ) : null}

      {showTrending ? (
        <div className="ss__autocomplete__inner-wrapper">
          {trendingTitle ? (
            <div className="ss__autocomplete__title ss__autocomplete__title--trending">
              <h5 className="ss__autocomplete__terms--heading eyebrow eyebrow--medium">
                {trendingTitle}
              </h5>
            </div>
          ) : null}
          <div className="ss__autocomplete__terms__options">
            { trending.length > 0 ? ( 
              <>
                {trending.map((term) => (
                  <div
                    className={classnames("ss__autocomplete__terms__option", {
                      "ss__autocomplete__terms__option--active": term.active,
                    })}
                  >
                    <a
                      onClick={(e) => onTermClick && onTermClick(e)}
                      href={term.url.href}
                      {...valueProps}
                      onFocus={() => term.preview()}
                    >
                      {emIfy(term.value, state.input)}
                    </a>
                  </div>
                ))}
              </>
            ):
              <>
                <div
                    className={classnames("ss__autocomplete__terms__option")}
                  >
                    <a>
                      No Results.
                    </a>
                  </div>
              </>
            }
          </div>
        </div>
      ) : null}
    </>
  );
};
